/**
 * Replace accented characters with their base equivalents
 * E.g., "Moatjé" -> "Moatje", "Café" -> "Cafe"
 */
export function removeAccents(text: string): string {
  if (!text) return text;
  // Keep Swedish letters å, ä, ö as they are proper letters in the Swedish alphabet
  // Only remove foreign accents like é, è, ê, etc.
  return text
    .replace(/[éèêë]/g, 'e')
    .replace(/[ÉÈÊË]/g, 'E')
    .replace(/[áàâã]/g, 'a')
    .replace(/[ÁÀÂÃ]/g, 'A')
    .replace(/[íìîï]/g, 'i')
    .replace(/[ÍÌÎÏ]/g, 'I')
    .replace(/[óòô]/g, 'o')
    .replace(/[ÓÒÔ]/g, 'O')
    .replace(/[úùû]/g, 'u')
    .replace(/[ÚÙÛ]/g, 'U')
    .replace(/[ýÿ]/g, 'y')
    .replace(/[ÝŸ]/g, 'Y')
    .replace(/[ñ]/g, 'n')
    .replace(/[Ñ]/g, 'N')
    .replace(/[ç]/g, 'c')
    .replace(/[Ç]/g, 'C');
}

/**
 * Capitalize first letter, lowercase rest
 * E.g., "HELLO WORLD" -> "Hello world"
 */
export function capitalizeFirst(text: string): string {
  if (!text || text.length === 0) return text;
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}

/**
 * Normalize a word for storage: first letter uppercase, rest lowercase
 * Removes foreign accents (é -> e) but keeps Swedish letters (å, ä, ö)
 * E.g., "MOATJÉ" -> "Moatje", "FÖRORDAT" -> "Förordat"
 */
export function normalizeWord(word: string): string {
  if (!word || word.length === 0) return word;
  const withoutAccents = removeAccents(word);
  return withoutAccents.charAt(0).toUpperCase() + withoutAccents.slice(1).toLowerCase();
}

/**
 * Normalize a clue for storage: first letter uppercase, rest lowercase
 * Keeps accents intact since clues can have special characters
 * E.g., "VARM ÅRSTID" -> "Varm årstid"
 */
export function normalizeClue(clue: string): string {
  if (!clue || clue.length === 0) return clue;
  return clue.charAt(0).toUpperCase() + clue.slice(1).toLowerCase();
}
